export enum UserRoles {
  Supplier = 'Supplier',
  Operator = 'Operator',
}
